/**
 * api接口
 *      import * as api from '../api.js';
 *      api.signin();
 */

import router from '../router';
import { Message } from 'element-ui';
import Axios from 'axios';
import qs from 'qs';
import i18n from '../components/lang/index.js';

/*
 * 封装Axios
 * @param string url 请求的URL地址
 * @param Object params post发送的数据/get的参数
 * @param Object opts 请求的设置项
 *      loading:设置是否现实loading菊花
 *      method：设置get|post|put|delete提交，默认是get
 *
 * @return Promise 返回Promise对象
 *
 */
let request = (url, params = {}, opts = {}) => {
  // console.log(`api.request：`, url, params, opts);
  // 组装请求的param
  let headers = {};
  let lang = localStorage.getItem('language')
  let language = (lang && (lang == 'en-US' || lang == 'en_US')) ? 'en-US' : 'zh-CN'
  if (sessionStorage.getItem('Authorization')) {
    headers[process.env.AUTHORIZATION] = 'bearer ' + sessionStorage.getItem('Authorization');
    headers.language = language;
  } else {
    headers = null
  }
  if (sessionStorage.getItem('abId') ) {
    headers["x-abId-header"] = sessionStorage.getItem('abId');
  }
  if (sessionStorage.getItem('orgId')) {
    headers["x-orgId-header"] = sessionStorage.getItem('orgId');
  }
  let param = {
    url: process.env.BASE_API + url,
    method: opts.method || 'get',
    responseType: opts.responseType || 'json',
    // 用户认证token
    headers: headers,
    params: {},
  };
  //  post||put请求
  if (param.method.toLowerCase() === 'post' && opts.contentType) {
    param.headers['Content-Type'] = opts.contentType;
    param.data = qs.stringify(params);
  } else if ((param.method.toLowerCase() === 'post' && !opts.contentType) || param.method.toLowerCase() === 'put') {
    param.data = params
  } else {
    // get||delete请求
    param.params = Object.assign(param.params, params);
  }
  //  发起请求
  return Axios.request(param)
    .then(res => {
      if (res && res.data && res.status === 200) {
        // 正常返回
        return Promise.resolve(res.data);
      }
    })
    .catch(e => {
      return Promise.reject(e)
    });
};
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
Axios.interceptors.response.use(response => {
  let Authorization = sessionStorage.getItem('Authorization');
  if (Authorization) {
    response.headers.Authorization = 'bearer ' + Authorization;
  }
  let abId = sessionStorage.getItem('abId');
  if (abId) {
    response.headers["x-abId-header"] = abId;
  }
  if (response.data.code == 6) {
    router.push({
      path: '/no-permission',
      query: {
        type: 6
      }
    })
  }
  return response;
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 400: Message.error('请求错误(400)'); break;
      case 401:
        localStorage.clear();
        sessionStorage.clear();
        router.push({
          path: '/'
        })
        Message.error({ showClose: true, message: i18n.t('登录已过期，请重新登录') })
        break;
      case 403: Message.error({ showClose: true, message: '拒绝访问(403)' }); break;
      case 404: Message.error({ showClose: true, message: '请求出错(404)' }); break;
      case 408: Message.error({ showClose: true, message: '请求超时(408)' }); break;
      case 500: Message.error({ showClose: true, message: '服务器错误(500)' }); break;
      case 501: Message.error({ showClose: true, message: '服务未实现(501)' }); break;
      case 502: Message.error({ showClose: true, message: '网络错误(502)' }); break;
      case 503: Message.error({ showClose: true, message: '服务不可用(503)' }); break;
      case 504: Message.error({ showClose: true, message: '网络超时(504)' }); break;
      case 505: Message.error({ showClose: true, message: 'HTTP版本不受支持(505)' }); break;
      default: Message.error({ showClose: true, message: `连接出错(${error.response.status})!` });
    }
  }
  return Promise.reject(error)
  //return Promise.resolve(error);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知
});


export default request



// WEBPACK FOOTER //
// ./src/api/api.js